import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benchmarks = [{
  name: "Blackstone",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/logo_blackstone.png"
}, {
  name: "Apollo",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/logo_apollo.png"
}, {
  name: "Brookfield",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/logo_brookfield.png"
}, {
  name: "KKR",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/logo_kkr.png"
}];
export default function MarketBenchmarks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="market-benchmarks" ref={ref} className={cn("dark bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6">
        {}
        <div className="mb-8">
          <h2 className="text-[14px] uppercase tracking-widest text-muted-foreground font-medium">
            Strategic Alignment
          </h2>
        </div>

        {}
        <div className="border-y border-white/20 flex flex-col md:flex-row">
          {}
          <div className="flex items-center py-8 md:py-0 md:pr-12 md:w-1/3 border-b md:border-b-0 md:border-r border-white/20">
            <p className="text-lg md:text-xl font-serif leading-tight text-white/90">
              Positioned alongside global leaders in capital management.
            </p>
          </div>

          {}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4">
            {benchmarks.map((item, i) => <div key={item.name} data-index={i} className={cn("relative flex items-center justify-center p-8 md:p-10", i !== benchmarks.length - 1 ? "md:border-r border-white/20" : "", i < 2 ? "border-b md:border-b-0 border-white/20" : "", i % 2 === 0 ? "border-r md:border-r-0 border-white/20" : "")}>
                <div className="w-full max-w-[120px] opacity-60 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500">
                  <AspectRatio ratio={3 / 1}>
                    <img src={item.logo} alt={`${item.name} logo`} className="h-full w-full object-contain" />
                  </AspectRatio>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}